module.exports = __webpack_public_path__ + "static/img/out11.e0530064.png";